import { Component, inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { PartnersService } from '../../../services/partners.service';
import { PartnerUnique } from '../../../model/partner.model';
import { ItemComponent } from './item/item.component';

@Component({
    selector: 'app-partners-salons',
    templateUrl: './partners-salons.component.html',
    styleUrls: ['./partners-salons.component.scss'],
    imports: [CommonModule, TranslateModule, RouterModule, ItemComponent],
})
export class PartnersSalonsComponent implements OnInit {
    private partnersService = inject(PartnersService);

    @Input({ required: true }) voivodeship!: string;

    partnersUnique$!: Observable<PartnerUnique[]>;

    ngOnInit(): void {
        this.partnersUnique$ = this.partnersService.partnersUnique$(this.voivodeship);
    }
}
